import { GET_SOCIALCOUNT } from "../const";

export const getSocialCount = (data: any) => {
    return {
        type: GET_SOCIALCOUNT,
        payload: data,
    };
};
